import { ROLLOUT_WAVEFORM } from 'constants/featureFlag';

import { useFlagIsActivated } from 'hooks/featureFlag';

export const useShouldShowWaveform = (): boolean => {
  const isInWaveformFlag = useFlagIsActivated({
    flag: ROLLOUT_WAVEFORM,
    activationValues: ['show-new'],
  });

  return isInWaveformFlag;
};
